const apiUrl = process.env.REACT_APP_EVENT_API_URL
const webUrl = process.env.REACT_APP_WEB_APP_ROOT

const isDev = process.env.REACT_APP_IS_DEV === 'true'

const fullWebUrl = isDev ? `http://${webUrl}` : `https://app.${webUrl}`

export const OBVIO_WIDGET_LOADER_URL = `${fullWebUrl}/widget/obvio_widget_loader.gif`
export const OBVIO_WIDGET_API_BASE = `${apiUrl}/`
